<div
  class="subscribe-dialog common-style form public-mode"
  [attr.data-theme]="data?.isDarkTheme ? 'dark' : 'light'"
  [class.dark-theme]="data?.isDarkTheme"
  [class.light-theme]="!data?.isDarkTheme"
  [style.--status-primary]="data?.primaryColor || null">
  <div class="dialog-header d-flex align-items-center justify-content-between">
    @if (currentStep === 'channel') {
      <h3 class="dialog-title mb-0">Choose Notification Channel</h3>
    }
    @if (currentStep === 'service-selection') {
      <h3 class="dialog-title mb-0">Select Services to Monitor</h3>
    }
    @if (currentStep === 'verifying') {
      <h3 class="dialog-title mb-0">Verify Your Subscription</h3>
    }
    @if (currentStep === 'completed') {
      <h3 class="dialog-title mb-0">Subscription Completed</h3>
    }
    @if (currentStep === 'unsubscribed') {
      <h3 class="dialog-title mb-0">Unsubscribed</h3>
    }
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (currentStep === 'channel') {
    <div class="channel-tabs" role="tablist" aria-label="Notification channels">
      <div class="tab-row" [style.gridTemplateColumns]="'repeat(' + (availableChannels.length || 1) + ', minmax(0, 1fr))'">
        @for (channel of availableChannels; track trackByChannelId(i, channel); let i = $index) {
          <button
            type="button"
            class="tab-pill"
            [class.active]="activeTabIndex === i"
            (click)="onChannelSelected(i)">
            <mat-icon>{{ channel.icon }}</mat-icon>
            <span class="channel-tab-label">{{ channel.label }}</span>
          </button>
        }
      </div>
    </div>
    <div class="tab-content" [formGroup]="form">
      @if (availableChannels[activeTabIndex]?.id === 'email') {
        <label class="form-label fw-bold" for="status-subscribe-email">Email Address</label>
        <input id="status-subscribe-email" type="email" class="form-control" formControlName="email" placeholder="you@example.com">
        @if (form.get('email')?.touched && !(form.get('email')?.value || '').trim()) {
          <small class="text-danger d-block mt-1">
            Email address is required.
          </small>
        }
        @if (form.get('email')?.touched && (form.get('email')?.value || '').trim() && form.get('email')?.hasError('email')) {
          <small class="text-danger d-block mt-1">
            Enter a valid email address.
          </small>
        }
      }
      @if (availableChannels[activeTabIndex]?.id === 'slack') {
        <label class="form-label fw-bold" for="status-subscribe-slack">Slack Channel</label>
        <input id="status-subscribe-slack" type="text" class="form-control" formControlName="slack" placeholder="#status-updates">
        @if (form.get('slack')?.touched && form.get('slack')?.invalid) {
          <small class="text-danger d-block mt-1">
            Slack channel is required.
          </small>
        }
      }
      @if (availableChannels[activeTabIndex]?.id === 'webhook') {
        <label class="form-label fw-bold" for="status-subscribe-webhook">Webhook URL</label>
        <input id="status-subscribe-webhook" type="text" class="form-control" formControlName="webhook" placeholder="https://...">
        @if (form.get('webhook')?.touched && !(form.get('webhook')?.value || '').trim()) {
          <small class="text-danger d-block mt-1">
            Webhook URL is required.
          </small>
        }
        @if (form.get('webhook')?.touched && (form.get('webhook')?.value || '').trim() && form.get('webhook')?.hasError('invalidWebhookUrl')) {
          <small class="text-danger d-block mt-1">
            Enter a valid webhook URL.
          </small>
        }
      }
      @if (availableChannels[activeTabIndex]?.id === 'sms') {
        <label class="form-label fw-bold" for="status-subscribe-sms">Phone Number</label>
        <div class="sms-phone-group">
          <ao-intl-tel-input
            [inputId]="'status-subscribe-sms'"
            [cssClass]="'form-control sms-phone-input'"
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="CountryISO.UnitedStates"
            [maxLength]="15"
            [phoneValidation]="true"
            [separateDialCode]="true"
            [dropdownContainer]="'body'"
            [dropdownPanelClass]="data?.isDarkTheme ? 'status-subscribe-country-dropdown status-subscribe-country-dropdown-dark' : 'status-subscribe-country-dropdown'"
            name="sms"
            formControlName="sms">
          </ao-intl-tel-input>
          @if (form.get('sms')?.touched && !form.get('sms')?.value) {
            <small class="text-danger d-block mt-1">
              Phone number is required.
            </small>
          }
          @if (form.get('sms')?.touched && form.get('sms')?.errors?.validatePhoneNumber) {
            <small class="text-danger d-block mt-1">
              Enter valid phone number.
            </small>
          }
        </div>
        <p class="subscribe-note">
          Message and data rates may apply. By subscribing you agree to the AlertOps
          <a href="https://alertops.com/terms-conditions/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
          and AlertOps
          <a href="https://alertops.com/privacy-policy/" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
        </p>
      }
      @if (availableChannels[activeTabIndex]?.id === 'msTeams') {
        <label class="form-label fw-bold" for="status-subscribe-ms-teams">MS Teams Webhook URL</label>
        <input id="status-subscribe-ms-teams" type="text" class="form-control" formControlName="msTeams" placeholder="https://...">
        @if (form.get('msTeams')?.touched && !(form.get('msTeams')?.value || '').trim()) {
          <small class="text-danger d-block mt-1">
            MS Teams webhook URL is required.
          </small>
        }
        @if (form.get('msTeams')?.touched && (form.get('msTeams')?.value || '').trim() && form.get('msTeams')?.hasError('invalidWebhookUrl')) {
          <small class="text-danger d-block mt-1">
            Enter a valid MS Teams webhook URL.
          </small>
        }
      }
    </div>
    @if (isLimitReached) {
      <small class="text-danger d-block mt-2">{{ limitMessage }}</small>
    }
    <div class="dialog-actions d-flex justify-content-end gap-2">
      <button mat-stroked-button class="action-btn neutral-btn" (click)="close()">Cancel</button>
      <button mat-flat-button color="primary" class="action-btn primary-btn" [disabled]="!isActiveValid || isLimitReached" (click)="onContinue()">
        Continue
      </button>
    </div>
  }

  @if (currentStep === 'service-selection') {
    <div class="service-selection-content">
      <div class="service-search-row">
        <div class="service-search-wrap">
          <input
            type="text"
            class="service-search-input"
            [value]="serviceSearchQuery"
            placeholder="Search services..."
            [disabled]="isSubmitting"
            (input)="onServiceSearchInput($event)" />
          @if (!hasActiveServiceSearch) {
            <mat-icon class="service-search-icon" aria-hidden="true">search</mat-icon>
          } @else {
            <button
              type="button"
              class="service-search-clear"
              aria-label="Clear search"
              [disabled]="isSubmitting"
              (click)="clearServiceSearch()">
              <mat-icon aria-hidden="true">close</mat-icon>
            </button>
          }
        </div>
        <button
          type="button"
          class="service-select-all-btn"
          [class.btn-active]="isAllServicesSelected"
          [disabled]="isSubmitting || serviceGroups.length === 0 && ungroupedServiceOptions.length === 0"
          (click)="onToggleAllServicesAction()">
          {{ serviceSelectionActionLabel }}
        </button>
      </div>
      <div class="service-list-wrapper" [class.disabled]="isSubmitting">
        <div class="service-list-panel">
          @if (servicesLoading) {
            <div class="d-flex justify-content-center py-3">
              <mat-progress-spinner [diameter]="26" mode="indeterminate"></mat-progress-spinner>
            </div>
          }
          @if (!servicesLoading) {
            @if (filteredServiceGroups.length > 0) {
              @for (group of filteredServiceGroups; track trackByServiceGroupId($index, group)) {
                <div class="group-block">
                  <div class="group-header">
                    <mat-checkbox
                      color="primary"
                      class="group-select-checkbox"
                      [attr.aria-label]="'Select ' + group.name"
                      [checked]="isServiceGroupSelected(group)"
                      [indeterminate]="isServiceGroupIndeterminate(group)"
                      [disabled]="isSubmitting"
                      (change)="toggleServiceGroup(group, $event.checked)">
                      <div class="group-header-text">
                        <span class="group-title">{{ group.name }}</span>
                        <span class="group-count">{{ group.services.length }} services</span>
                      </div>
                    </mat-checkbox>
                    <button
                      type="button"
                      class="group-expand-btn"
                      [disabled]="isSubmitting"
                      (click)="toggleGroupExpansion(group)">
                      <mat-icon class="group-toggle-icon">{{ group.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  </div>
                  @if (group.expanded) {
                    <div class="group-children">
                      @for (service of group.services; track trackByServiceSelectionId($index, service)) {
                        <div class="service-row group-service-row">
                          <mat-checkbox
                            color="primary"
                            [checked]="isServiceSelected(service)"
                            [disabled]="isSubmitting"
                            (change)="toggleService(service, $event.checked)">
                            <div class="service-row-content">
                              <span class="service-label">{{ service.name }}</span>
                              @if (service.description) {
                                <span class="service-description">{{ service.description }}</span>
                              }
                            </div>
                          </mat-checkbox>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            }
            @for (service of filteredUngroupedServiceOptions; track trackByServiceSelectionId($index, service)) {
              <div class="service-row ungrouped-row">
                <mat-checkbox
                  color="primary"
                  [checked]="isServiceSelected(service)"
                  [disabled]="isSubmitting"
                  (change)="toggleService(service, $event.checked)">
                  <div class="service-row-content">
                    <span class="service-label">{{ service.name }}</span>
                    @if (service.description) {
                      <span class="service-description">{{ service.description }}</span>
                    }
                  </div>
                </mat-checkbox>
              </div>
            }
            @if (hasActiveServiceSearch && !hasServiceSearchResults) {
              <div class="empty-services">
                No matching services found.
              </div>
            }
            @if (!hasActiveServiceSearch && serviceGroups.length === 0 && ungroupedServiceOptions.length === 0) {
              <div class="empty-services">
                No services available.
              </div>
            }
          }
        </div>
      </div>
      @if (serviceTreeTouched && !subscribeAllServices && selectedServiceIds.length === 0) {
        <small class="text-danger d-block mt-2">
          Select at least one service.
        </small>
      }
      @if (isLimitReached) {
        <small class="text-danger d-block mt-1">{{ limitMessage }}</small>
      }
      @if (submitError) {
        <div
          class="submit-feedback mt-2"
          [class.submit-feedback-error]="submitNoticeType === 'error'"
          [class.submit-feedback-info]="submitNoticeType === 'info'"
          role="alert"
          aria-live="assertive">
          <mat-icon>{{ submitNoticeType === 'error' ? 'error_outline' : 'info' }}</mat-icon>
          <span>{{ submitError }}</span>
        </div>
      }
    </div>
    @if (!showCloseOnlyAfterDuplicate) {
      <div class="dialog-actions d-flex justify-content-end gap-2">
        <button mat-stroked-button class="action-btn neutral-btn" [disabled]="isSubmitting" (click)="onBackToChannels()">Back</button>
        <button mat-flat-button color="primary" class="action-btn primary-btn" [disabled]="isSubmitting || isLimitReached" (click)="onSubscribe()">
          <span class="btn-label">Subscribe</span>
        </button>
      </div>
    }
    @if (showCloseOnlyAfterDuplicate) {
      <div class="dialog-actions d-flex justify-content-end gap-2">
        <button mat-flat-button color="primary" class="action-btn primary-btn" (click)="close()">
          Close
        </button>
      </div>
    }
  }

  @if (currentStep === 'verifying') {
    <div class="verification-state text-center">
      <div class="state-icon verifying">
        <mat-icon>{{ verificationIcon }}</mat-icon>
      </div>
      <h4>{{ verificationTitle }}</h4>
      <p>{{ verificationIntro }}</p>
      <p class="subtext">{{ verificationSubtext }}</p>
      @if (submitError) {
        <small class="text-danger d-block mt-2">{{ submitError }}</small>
      }
      @if (submitError) {
        <button mat-button class="btn-link mt-3 primary-text-btn" (click)="onBackToChannels()">
          Back
        </button>
      }
    </div>
    <div class="dialog-actions d-flex justify-content-center">
      <button mat-button color="primary" class="btn-link btn-add pe-0 primary-text-btn" (click)="close()">OK</button>
    </div>
  }

  @if (currentStep === 'completed') {
    <div class="verification-state text-center">
      <div class="state-icon completed">
        <mat-icon>done</mat-icon>
      </div>
      <h4>You're subscribed!</h4>
      <p>You'll receive notifications when there are status updates.</p>
      <p class="subtext">Use the link in your confirmation message to manage your subscription.</p>
    </div>
    <div class="dialog-actions d-flex justify-content-center">
      <button mat-button color="primary" class="btn-link btn-add pe-0 primary-text-btn" (click)="close()">Done</button>
    </div>
  }

  @if (currentStep === 'unsubscribed') {
    <div class="verification-state text-center">
      <div class="state-icon completed">
        <mat-icon>done</mat-icon>
      </div>
      <h4>You're unsubscribed.</h4>
      <p>You will no longer receive status page notifications for this subscription.</p>
    </div>
    <div class="dialog-actions d-flex justify-content-center">
      <button mat-button color="primary" class="btn-link btn-add pe-0 primary-text-btn" (click)="close()">Done</button>
    </div>
  }
</div>

